






import { Component, Vue } from "vue-property-decorator";
import SunsetsApp from "./components/SunsetsApp.vue";

@Component({
  components: {
    SunsetsApp
  }
})
export default class App extends Vue {}
